import React from 'react'

import { Link } from 'react-router-dom'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ROUND_LINK_STYLES =
  'flex justify-center items-center bg-contentareaborderselected text-contentareabackground rounded-full w-8 h-8'
const ROUND_LINK_INLINE_STYLES = { flex: '1 1 2rem' }

export interface ILinkProps {
  to: string
  color?: string
  icon: IconDefinition
}

export const IconLink: React.FC<ILinkProps> = ({ color, icon, to }) => (
  <Link
    style={ROUND_LINK_INLINE_STYLES}
    className={ROUND_LINK_STYLES}
    to={to}
    color={color}
  >
    <FontAwesomeIcon icon={icon} size="1x" />
  </Link>
)
